import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=3440b99a&scoped=true"
import script from "./FilesList.vue?vue&type=script&lang=js"
export * from "./FilesList.vue?vue&type=script&lang=js"
import style0 from "./FilesList.vue?vue&type=style&index=0&id=3440b99a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3440b99a",
  null
  
)

export default component.exports